import Container from "../Container";
import React from "react";
import SubscriptionForm from "../SubscriptionForm";
import { SubscriptionFormProps } from "../SubscriptionForm/SubscriptionForm";

export interface SubscriptionSectionProps {
  form?: SubscriptionFormProps;
}

const SubscriptionSection = ({ form }: SubscriptionSectionProps) => {
  return (
    <div className="w-full py-8 bg-gray-200">
      <Container>
        <div className="max-w-md mx-auto">
          <SubscriptionForm {...form} />
        </div>
      </Container>
    </div>
  );
};

export default SubscriptionSection;
